/* eslint-ignore */
// @ts-nocheck
import React, { Component } from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import { MdPlayArrow } from 'react-icons/md';
import IdleTimer from 'react-idle-timer';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Stepper from '~/components/layout/Stepper';
import List from '~/modules/Granel/pages/endereco/list';
import { signOut } from '~/utils/functions';
import classes from '../cadastro/cadastro.module.scss';
import { Content, ContStepper, Gradient, Scrollbar } from '../cadastro/styles';

class Home extends Component {
  constructor(props) {
    super(props);

    this.idleTimer = null;
    this.handleOnAction = this.handleOnAction.bind(this);
    this.handleOnActive = this.handleOnActive.bind(this);
    this.handleOnIdle = this.handleOnIdle.bind(this);

    this.state = {
      steppers: ['Seu endereço'],
    };
  }

  async componentDidMount() {
    const token = await localStorage.getItem(
      '@UltragazEmpresarial:accessToken'
    );
    if (!token) {
      window.location.href = '/';
    }
  }

  render() {
    return (
      <>
        <IdleTimer
          ref={(ref) => {
            this.idleTimer = ref;
          }}
          timeout={15 * 60 * 1000}
          onActive={this.handleOnActive}
          onIdle={this.handleOnIdle}
          onAction={this.handleOnAction}
          debounce={250}
        />
        <Scrollbar>
          <Content>
            <Container className={`${classes.container} px-0 mx-0`} fluid>
              <Row className={`${classes.row} px-0 mx-0`}>
                <Col
                  className={`${classes.col} ${classes.colBanner} px-0 mx-0`}
                >
                  <Gradient>
                    <Link to="/" className={classes.logo}>
                      <img
                        alt="Ultragaz Logotipo"
                        src="/static/ultragaz-logo-white.svg"
                      />
                    </Link>
                    <ContStepper>
                      <Stepper
                        activated={this.props.step}
                        steppers={this.state.steppers}
                      />
                    </ContStepper>
                  </Gradient>
                </Col>
                <Col className={`${classes.col} ${classes.colText} px-4 mx-0`}>
                  <Card className={`${classes.card} border-0`}>
                    <Card.Body className="first-access-top d-flex flex-column w-100 p-0 top-overflow">
                      <h1>                        
                        &nbsp;&nbsp;
                      </h1>
                      <List />
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Container>
          </Content>
        </Scrollbar>
      </>
    );
  }

  handleOnAction(event) {}

  handleOnActive(event) {}

  handleOnIdle(event) {
    signOut();
  }
}

const mapStateToProps = (state) => ({
  step: state.signUpReducer.step,
});

export default connect(mapStateToProps)(Home);
